
import React from 'react';


import MockStock  from 'views/MockStock';
const MiddleSchoolPage = () => {
  return <MockStock/>;
};

export default MiddleSchoolPage;